import { FC } from 'react';
import { Claims, PlatformType } from '@/_shared/constants';
import { DialogPaymentFailed } from '@/billing/components/DialogPaymentFailed';
import { DialogSubscriptionBetaExpired } from '@/billing/components/DialogSubscriptionBetaExpired';
import { DialogSubscriptionExpiredAdmin } from '@/billing/components/DialogSubscriptionExpiredAdmin';
import { DialogSubscriptionExpiredLearning } from '@/billing/components/DialogSubscriptionExpiredLearning';
import { DialogSubscriptionMissing } from '@/billing/components/DialogSubscriptionMissing';
import { getUserProfileCall } from '@/core/state/api';
import { ClaimsComponent } from '../Claims/Claims';

/**
 * Renders platform blocking dialogs that prevent the user from interacting
 * with the application until the underlying issue is resolved.
 */
export const BlockingDialogs: FC = () => {
  const { claims } = getUserProfileCall.hook();
  const hasBillingWrite = claims?.includes(Claims.BILLING_WRITE) ?? false;

  return (
    <>
      <DialogPaymentFailed />
      <ClaimsComponent platform={PlatformType.ADMIN} claimKey={Claims.BILLING_WRITE}>
        <DialogSubscriptionExpiredAdmin />
      </ClaimsComponent>
      {!hasBillingWrite && (
        <ClaimsComponent platform={PlatformType.ADMIN}>
          <DialogSubscriptionExpiredLearning />
        </ClaimsComponent>
      )}
      <ClaimsComponent platform={PlatformType.LEARNING}>
        <DialogSubscriptionExpiredLearning />
      </ClaimsComponent>
      <ClaimsComponent platform={PlatformType.ADMIN}>
        <DialogSubscriptionBetaExpired />
      </ClaimsComponent>
      <ClaimsComponent platform={PlatformType.ADMIN}>
        <DialogSubscriptionMissing />
      </ClaimsComponent>
    </>
  );
};
